import { Button } from "antd";
import styled, { css } from "styled-components";

import { ButtonVariant } from "./index";

export const StyledButton = styled(Button)<{
    $type: ButtonVariant;
    $dimension: number;
    $border: boolean;
}>`
    ${({ $dimension }) => css`
        width: ${$dimension}px !important;
        height: ${$dimension}px;
    `}
    border-radius: 50%;
    background: transparent;
    flex-shrink: 0;

    .ant-btn-icon {
        line-height: 0;
    }

    svg {
        font-size: ${({ $border }) => ($border ? "20px" : "24px")};
    }

    ${({ $type, theme, $border }) => {
        let color = "grey";

        switch ($type) {
            case "success":
                color = theme.colors.green;
                break;
            case "error":
                color = theme.dangerTypographyColor;
                break;
            default:
                color = theme.disabledTypographyColor;
                break;
        }

        return css`
            border: ${$border ? `1px solid ${color}` : "none"};
            color: ${color};

            &:disabled {
                color: ${color};
            }

            &:hover {
                border: ${$border ? `1px solid ${color}` : "none"};
                color: ${color} !important;
            }
        `;
    }}
`;
